import { ReactNode } from "react";

/**
 * LegendComponent
 */

type Props = {
  label?: string,
  children?: ReactNode,
};

export const LegendComponent = ({
  label,
  children,
}: Props) => {
  return (
    <div className="flex flex-col flex-wrap mb-4">
      {
        label &&
        <span className="font-bold text-sm text-black dark:text-white">
          {label}
        </span>
      }
      <div className="flex flex-row gap-6">
        {children}
      </div>
    </div>
  );
}